import { render, staticRenderFns } from "./Exposure.vue?vue&type=template&id=bb62d540&scoped=true"
import script from "./Exposure.vue?vue&type=script&lang=js"
export * from "./Exposure.vue?vue&type=script&lang=js"
import style0 from "./Exposure.vue?vue&type=style&index=0&id=bb62d540&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb62d540",
  null
  
)

export default component.exports